import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import {ResponseType} from "./ResponseType";
import {getMessage} from "../util";

const NotFound = (props:ResponseType) => {
    return(
        <Row className={"justify-content-center"}>
            <Col xs={12} sm={11} md={9} lg={7} className={"text-center"}>
                <p className={"lead"}>Según nuestros registros usted no está habilitado para participar en esta votación. Puede solicitar una revisión rellenando el siguiente formulario:</p>
                <Button className="EvColorGrisLight m-1 form-button" href="https://evoting.typeform.com/to/GwsXMawe"
                        variant="primary">FORMULARIO</Button><br/>
                <Button className="EvColorGrisLight m-1 mt-3 form-button2" href="/j91hrrLU"
                        variant="primary">VOLVER A CONSULTAR</Button>
            </Col>
        </Row>
    )
}

export default NotFound;
